import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4)
  },
  paper: {
    padding: theme.spacing(4),
    maxWidth: 700,
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  msgBox: {
    padding: theme.spacing(2),
    borderRadius: '8px',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    textAlign: 'left',
    maxWidth: '600px',
    overflowX: 'auto',
    fontSize: '0.9rem'
  },
  button: {
    marginTop: theme.spacing(2)
  }
}));
